import Context from './Context.js';

export default class ReturningUsers extends Context {
  constructor() {
    super();
    this.data = {
      last_viewed_vehicles: false,
      viewed_vehicle_ids: [],
      searched_vehicles: false,
      previous_enquiries: false,
      enquiry_type_ids: []
    };
  }

  static get key() {
    return 'returning_users_event_context'
  }

  setData(lastViewedVehicles, hasSearched, sentEnquiries) {
    this.data = {
      last_viewed_vehicles: !!lastViewedVehicles.length,
      viewed_vehicle_ids: lastViewedVehicles.map((index) => Number(index)),
      searched_vehicles: !!hasSearched,
      previous_enquiries: !!sentEnquiries.length,
      enquiry_type_ids: sentEnquiries.map((index) => Number(index))
    };
  }
}
